<template>
  <div>
    <confirm-dialog ref="confirmDeleteDialog"
                    confirm-button-color="deep-orange"
                    v-bind:cancel-button-label="$t('cancel')"
                    v-bind:confirm-button-label="$t('delete')"
                    v-bind:message="$t('areYouSureYouWantToDeleteThisLearningTenantIrrevocably')"
                    v-bind:title="$t('deleteLearningTenant')"
                    v-model="confirmDeleteDialog" />

    <v-snackbar color="deep-orange"
                right
                top
                v-model="validationSnackbar">
      {{ $t('thereAreItemsThatRequireYourAttention') }}
    </v-snackbar>

    <top-header v-bind:title="title | defaultValue($t('learningTenant'))">
      <header-button icon="mdi-chevron-left"
                     slot="left-button"
                     v-bind:label="$t('back')"
                     v-bind:to="{ name: 'learning-tenants' }" />

      <header-button icon="mdi-check"
                     right
                     slot="right-button"
                     v-bind:label="$t('save')"
                     v-on:click="updateLearningTenant" />

      <v-menu slot="menu">
        <template v-slot:activator="{ on, attrs }">
          <v-btn dark
                 icon
                 v-bind="attrs"
                 v-on="on">
            <v-icon>mdi-dots-vertical</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-on:click="deleteLearningTenant">
            <v-list-item-title class="deep-orange--text">{{ $t('delete') }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </top-header>

    <v-progress-linear indeterminate
                       v-bind:active="loading" />

    <v-container v-if="learningTenant != null">
      <v-row>
        <v-col cols="12"
               lg="6">
          <learningTenant-details-card ref="learningTenantDetailsCard"
                                v-bind:learningTenant="learningTenant" />
        </v-col>
      </v-row>
    </v-container>

  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import ConfirmDialog from '@/components/common/ConfirmDialog'
  import HeaderButton from '@/components/common/HeaderButton.vue'
  import TopHeader from '@/components/common/TopHeader.vue'
  import LearningTenantDetailsCard from '@/components/learning/LearningTenantDetailsCard.vue'

  export default {
    async beforeRouteUpdate(to, from, next) {
      const id = parseInt(to.params.id)

      await this.get(id)

      next()
    },
    components: {
      ConfirmDialog,
      HeaderButton,
      LearningTenantDetailsCard,
      TopHeader
    },
    computed: {
      id() {
        return this.learningTenant?.id
      },
      title() {
        return this.learningTenant?.title
      },
      ...mapGetters({
        getLearningTenant: 'learning/learningTenant'
      })
    },
    async created() {
      const id = parseInt(this.$route.params.id)

      await this.get(id)
    },
    data: () => ({
      confirmDeleteDialog: false,
      loading: false,
      learningTenant: null,
      validationSnackbar: false
    }),
    methods: {
      async deleteLearningTenant() {
        await this.$refs.confirmDeleteDialog.open(async r => {
          if (!r) {
            return
          }

          this.loading = true

          await this.doDeleteLearningTenant({ id: this.id })

          this.loading = false

          this.$router.push({ name: 'learning-tenants' })
        })
      },
      async get(id) {
        this.loading = true

        await this.loadLearningTenant({ id })

        this.loading = false

        this.learningTenant = Object.assign({}, this.getLearningTenant(id))
      },
      async updateLearningTenant() {
        if (!this.$refs.learningTenantDetailsCard.validate()) {
          this.validationSnackbar = true

          return
        }

        this.loading = true

        await this.doUpdateLearningTenant({ learningTenant: this.learningTenant })

        this.loading = false

        this.$router.push({ name: 'learning-tenants' })
      },
      ...mapActions({
        doDeleteLearningTenant: 'learning/deleteLearningTenant',
        doUpdateLearningTenant: 'learning/updateLearningTenant',
        loadLearningTenant: 'learning/loadLearningTenant'
      })
    },
    name: 'LearningTenant'
  }
</script>


<i18n>
  {
    "de": {
      "areYouSureYouWantToDeleteThisLearningTenantIrrevocably": "Sind Sie sicher, dass Sie diesen Mandanten unwiderruflich löschen möchten?",
      "back": "Zurück",
      "cancel": "Abbrechen",
      "delete": "Löschen",
      "deleteLearningTenant": "Mandant löschen",
      "save": "Speichern",
      "learningTenant": "Mandant",
      "thereAreItemsThatRequireYourAttention": "Es gibt Felder, die Ihre Aufmerksamkeit erfordern."
    },
    "en": {
      "areYouSureYouWantToDeleteThisLearningTenantIrrevocably": "Are you sure you want to delete this tenant irrevocably?",
      "back": "Back",
      "cancel": "Cancel",
      "delete": "Delete",
      "deleteLearningTenant": "Delete tenant",
      "save": "Save",
      "learningTenant": "Tenant",
      "thereAreItemsThatRequireYourAttention": "There are items that require your attention."
    }
  }
</i18n>